import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, concatMap, delay, from, last, map, Observable, of, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MsAuthService } from './ms-auth.service';

export interface IOutboundMessage {
  data: {
    PhoneNumber: string;
    ActivityUUID: string;
    BusinessPartnerID: string;
    Direction: string;
    ESObjectID: string;
    IsBTDRef: string;
    LoggedInUserID: string;
    ObjectID: string;
    ObjectThingType: string;
    ObjectTypeCode: string;
    ObjectUUID: string;
  },
  origin: string;
  type: string;
}

export interface IOutboundEventRequest {
  ActivityID: string;
  PhoneNumber: string;
  EmployeeID: string;
}
interface IEventDocument {
  docId: string;
  docData: IEventData;
}

interface IEventData extends IDictionay {
  Type: string;
  Email: string,
  EventType: string,
  ExternalReferenceID: string,
  ExternalOriginalReferenceID: string;
  Event: string,
  EmployeeID: string;
  Timestamp: number
}

interface IDictionay {
  [key: string]: any; // skipcq
}

export enum EFixedVerbs{
  Event_Deletion_Message='Events deletion failed!'
}

@Injectable({
  providedIn: 'root'
})
export class QueryEventsService {
  private _baseUrl: string;
  private _fieldsToIgnore = ["EmployeeID, Timestamp"];
  private _threshHold = 5;
  constructor(
    private _httpClient: HttpClient,
    private _authService: MsAuthService,
  ) {
    this._baseUrl = `${environment.apigee.host}`;
  }

  public processQueryEvents(employeeId: string): Observable<boolean> {
    const fetchUrl = this._baseUrl + environment.apigee.inboundPath;
    const fetchOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this._authService?.accessToken?.accessToken}`
      })
    };
    return this._httpClient.post<any>(fetchUrl, { employeeId }, fetchOptions).pipe(
      switchMap((result: IEventDocument[]) => {
        if (result.length > 0) {
          let targetEvents = result;
          let eventToDelete: string[] = [];
          return from(targetEvents).pipe(
            concatMap((event)=>{
              let messageData = event.docData;
              if(messageData){
                this._fieldsToIgnore.forEach((field: string) => {
                  if(messageData[field]) delete messageData[field];
                });
                window.parent.postMessage({ payload: messageData }, environment.ctiTargetOrigin);
                eventToDelete.push(event.docId);
              }
              return of(event).pipe(delay(2000));
            }),
            last(),
            switchMap(() => {
              const deleteUrl = this._baseUrl + environment.apigee.deletionPath;
              const deleteOptions = {
                headers: new HttpHeaders({
                  "Content-Type": "application/json",
                  "Authorization": `Bearer ${this._authService?.accessToken?.accessToken}`
                })
              };
              if(eventToDelete && eventToDelete.length > 0){
                return this._httpClient.post<any>(deleteUrl, { documentIds: eventToDelete }, deleteOptions).pipe(
                  map((_) => {
                    return result.length > this._threshHold;
                  }),
                  catchError(err => {
                    console.warn(err);
                    throw err;
                    // throw Error(EFixedVerbs.Event_Deletion_Message);
                  })
                )
              }
              return of(false);
            })
          )
        } else {
          return of(false);
        }
      }),
      catchError(err => {
        console.error(err);
        throw err;
      })
    )
  }


  public outboundEvents(event: IOutboundEventRequest): Observable<any> {
    let outboundUrl = this._baseUrl + environment.apigee.outboundPath;
    const outboundOption = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this._authService?.accessToken?.accessToken}`
      })
    };
    return this._httpClient.post(outboundUrl, event, outboundOption).pipe(
      catchError((e) => {
        console.error(e);
        throw e;
      })
    )
  }

  private _delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
